import type { WineProductItem } from '@/common/domain-model/product-search';
import { Col, Divider, Image, Row } from 'antd';
import type { FC } from 'react';
import { WineDetailItem } from './WineDetailItem';
import { WineProfileItem } from './WineProfileItem';

export const DetailView: FC<{ productItem: WineProductItem }> = ({
  productItem,
}) => {
  return (
    <div className="flex gap-4 p-5">
      <Image
        width={300}
        preview={false}
        src={productItem.data.image_urls?.[0] || ''}
      />
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          <span>Grape Varieties</span>
          <span>{productItem.data.grape}</span>
        </div>
        <Divider className="my-2" />
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-bold">Wine Profile</h3>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <WineProfileItem
                title="Body"
                value={productItem.data.body}
                infoText={['Light', 'Medium', 'Full']}
              />
            </Col>
            <Col span={12}>
              <WineProfileItem
                title="Acidity"
                value={productItem.data.acidity}
                infoText={['Light', 'Medium', 'High']}
              />
            </Col>
            <Col span={12}>
              <WineProfileItem
                title="tannins"
                value={productItem.data.tannins}
                infoText={['Soft', 'Medium', 'Firm']}
              />
            </Col>
            <Col span={12}>
              <WineProfileItem
                title="Sweetness"
                value={productItem.data.sweetness}
                infoText={['Dry', 'Off-Dry', 'Sweet']}
              />
            </Col>
          </Row>
        </div>
        <Divider className="my-2" />
        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-bold">Wine Details</h3>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <WineDetailItem
                title="Alcohol"
                value={`${productItem.data.alcohol || 'N/A'}%`}
              />
            </Col>
            <Col span={12}>
              <WineDetailItem
                title="Region"
                value={productItem.data.country || 'N/A'}
              />
            </Col>
            <Col span={12}>
              <WineDetailItem
                title="Vintage"
                value={productItem.data.year || 'N/A'}
              />
            </Col>
            <Col span={12}>
              <WineDetailItem
                title="Winery"
                value={productItem.data.producer || 'N/A'}
              />
            </Col>
            <Col span={12}>
              <WineDetailItem
                title="Supplier"
                value={productItem.supplier_name || 'N/A'}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
